<div class="checkbox-container" [attr.data-id]="controlId + 'checkbox-container-' + label">
  <label
    #checkbox
    class="checkbox"
    [class]="{
      'checked': value,
      'disabled': disabled,
      'small': size === 'small',
      'medium': size === 'medium'
    }"
    (click)="$event.preventDefault()"
  >
    <input #input class="value-holder" type="checkbox" [attr.data-id]="controlId + 'checkbox-input-' + value" [value]="value" [disabled]="disabled"/>
    <i class="icon-check fa fa-check" [style]="{ color: color }"></i>
  </label>

  @if (label) {
    @if (labelIconClass) {
      <i class="ml-2" [class]="labelIconClass"></i>
      <span class="ml-1 label" [class]="{ 'disabled': disabled, 'bold': boldLabel }">{{ label }}</span>
    } @else {
      <span class="label ml-2" [class]="{ 'disabled': disabled, 'bold': boldLabel }">{{ label }}</span>
    }

    @if (helperText) {
      <br>
      <span class="helper-text" [class]="{ 'disabled': disabled }">{{ helperText }}</span>
    }
  }
</div>
